import WorkflowActionsRoute from 'cio/pods/base/setup/workflow/actions/route';
import { action } from '@ember/object';

export default class ActionsRoute extends WorkflowActionsRoute {
  model() {
    // Reload the campaign. The single campaign payload has action
    // warnings which we want on the workflows screen so that we can ask users
    // to review any actions that were copied and modified. Otherwise, ember
    // serves the cached record from the store.
    return this.modelFor('broadcasts.broadcast').reload();
  }

  @action
  loading(transition) {
    // If coming from the broadcast_loading route, don't show this route's
    // loading template again.
    // If we do show it, the UI will jump between loading routes, which makes
    // for a jarring experience.
    // If we don't render this route, the parent loading route will keep
    // spinning until this route resolves properly.
    if (transition.from?.name.includes('broadcast_loading')) {
      return false;
    }

    return true;
  }
}
